<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Inspecciones Calidad</h1>
          <b-spinner v-if="loading" variant="primary" class="ml-2" small label="Small Spinner"></b-spinner>
        </b-col>
      </b-row>
      <v-client-table :data="tableData" :columns="columns" :options="options" v-if="ready">
        <template #actions="row">
          <span :id="'actions' + row.row.id">
            <a href="javascript:;" @click.prevent="showDetailModal(row)">
              <i class="fa fa-lg fa-search pr-1"></i>
            </a>
            <a href="javascript:;" @click.prevent="downloadWithAxios(row.row)">
              <i class="fa fa-lg fa-file-pdf-o"></i>
            </a>
            <email-modal-cmf
              :item="row.row"
              :productores="productores"
              @update-row="updateRow($event)"
              v-if="row.row.estado !== 'enviado'"
            />
          </span>
        </template>
        <template #notaFinal="row">
          <modal-detalle-inspeccion :id="row.row.id" :item="row.row"></modal-detalle-inspeccion>
          <b-badge
            @click.prevent="showDetailModal(row)"
            :variant="
              row.row.notaDefectosCriticos == 2 ? 'success' : row.row.notaDefectosCriticos == 3 ? 'warning' : 'danger'
            "
            >{{ row.row.notaFinal }}</b-badge
          >
        </template>
        <template slot="afterFilter">
          <tr class="VueTables__no-results">
            <b-link
              href="https://docs.google.com/spreadsheets/d/1aLrw2ynTZDgbC3WFqkyY4dHzrkX8KosQ4k7MHN66_eA/export?gid=0&format=xlsx"
              class="btn btn-secondary btn-sm ml-2"
              >Descargar xlsx</b-link
            >
          </tr>
          <tr v-if="loading" class="VueTables__no-results">
            <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
          </tr>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tableTexts from "../../lang/tableTexts";
import ModalDetalleInspeccion from "./ModalDetalleInspeccion.vue";
import EmailModalCMF from "./EmailModalCMF.vue";
export default {
  name: "InspectionListCMF",
  components: {
    ModalDetalleInspeccion,
    "email-modal-cmf": EmailModalCMF
  },
  data() {
    return {
      ready: false,
      loading: true,
      columns: [
        "id",
        // "datosGrales",
        "responsableInspeccion",
        // "responsableCalidad",
        // "informacionDeLaGuia",
        "guia",
        "fechaRecepcion",
        // "horaRecepcion",
        "productor",
        "fechaDeCosecha",
        "variedad",
        "cantidadBins",
        // "observacionRecepcion",
        // "infTraslado",
        // "nombreChofer",
        // "patenteCamion",
        // "libreRestosVegetales",
        // "pisoLimpio",
        // "sanitizacion",
        // "usoDeMallaOCarpa",
        "conforme",
        // "tTransporte",
        // "observacionTransporte",
        // "inspecion",
        "fechaInspeccion",
        "horaInspeccion",
        // "muestras",
        // "cantidadDeFrutos",
        // "tamañoMuestraGrs",
        "lote",
        // "nBinsInspeccionados",
        "temperatura",
        // "parametrosCriticos",
        // "pudricionGrs",
        // "porcentajePudricion",
        // "deshidratacion",
        // "porcentajeDeshidratacion",
        // "notaDeshidratacion",
        // "totalDefCriticosGrs",
        "totalDefCriticosPorcentaje",
        // "notaDefectosCriticos",
        // "parametrosNoCriticos",
        // "materialExtrano",
        // "porcerntajeMaterialExtrano",
        // "heridasPartiduras",
        // "porcentajeHeridasPartiduras",
        // "echandes",
        // "porcentajeEchandes",
        // "tabicado",
        // "porcentajeTabicado",
        // "manchasVerdes",
        // "porcentajeManchasVerdes",
        // "manchasBlancas",
        // "porcentajeManchasBlancas",
        // "totalDefNoCritcosGrs",
        "totalPorcentajeDefectosNoCriticos",
        // "notaNoCriticos",
        "notaFinal",
        "estado",
        // "fotos",
        // "defecto1",
        // "linkDefecto1",
        // "calibres",
        // "menor26Mm",
        // "porcentajeMenor26Mm",
        // "26Mm",
        // "porcentaje26Mm",
        // "2728Mm",
        // "porcentaje2728Mm",
        // "2930Mm",
        // "porcentaje2930Mm",
        // "31Mm",
        // "porcentaje31Mm",
        // "32Mm",
        // "porcentaje32Mm",
        // "33Mm",
        // "porcentaje33Mm",
        // "mayor33Mm",
        // "porcentajeMayor33Mm",
        "actions"
      ],
      productores: [],
      tableData: [],
      options: {
        texts: tableTexts,
        columnsClasses: {
          actions: "w-5 text-center"
        },
        // rowClassCallback: (row) => {
        //   const bootstrapColor = {
        //     2: "bg-success-muted",
        //     3: "bg-warning-muted",
        //     4: "bg-danger-muted"
        //   };
        //   return bootstrapColor[row["notaDefectosCriticos"]];
        // },

        headings: {
          id: "ID",
          responsableInspeccion: "Responsable Inspección",
          guia: "Guía",
          fechaRecepcion: "Fecha Recepción",
          productor: "Productor",
          fechaDeCosecha: "Fecha Cosecha",
          variedad: "Variedad",
          cantidadBins: "Cantidad Bins",
          conforme: "Conforme",
          fechaInspeccion: "Fecha Inspección",
          horaInspeccion: "Hora Inspección",
          lote: "Lote",
          temperatura: "Temperatura",
          totalDefCriticosPorcentaje: "Total Defectos Críticos (%)",
          notaDefectosCriticos: "Nota Defectos Críticos",
          totalPorcentajeDefectosNoCriticos: "Total Defectos No Críticos (%)",
          notaNoCriticos: "Nota Defectos No Críticos",
          notaFinal: "Nota Final",
          actions: ""
        },
        perPage: 25,
        columnsDisplay: {
          id: "",
          responsableInspeccion: "min_desktop",
          guia: "",
          fechaRecepcion: "",
          productor: "",
          fechaDeCosecha: "min_desktop",
          variedad: "min_desktop",
          cantidadBins: "min_desktop",
          conforme: "min_desktop",
          fechaInspeccion: "min_desktop",
          horaInspeccion: "min_desktop",
          lote: "min_desktop",
          temperatura: "min_desktop",
          totalDefCriticosPorcentaje: "min_desktop",
          notaDefectosCriticos: "min_desktop",
          totalPorcentajeDefectosNoCriticos: "min_desktop",
          notaNoCriticos: "min_desktop",
          notaFinal: "",
          estado: "min_desktop",
          actions: "min_desktop"
        }
      }
    };
  },
  filters: {
    datetime(value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  methods: {
    updateRow(e) {
      // Update row in tableData finding it by id
      const index = this.tableData.findIndex((row) => row.id === e.id);
      this.tableData[index]["estado"] = "enviado";
    },
    showDetailModal(e) {
      // Show the modal only if the user clicked outside the span #action
      this.$bvModal.show("modal-detalle-inspeccion-" + e.row.id);
    },
    async getProductores() {
      try {
        const response = await this.$axios.get(
          "https://api.sheety.co/17a15e538248668e7a07764e201fdfa9/calidadCmf/productores"
        );
        this.productores = response.data.productores;
      } catch (error) {
        console.log(error);
      }
    },
    async getData() {
      try {
        const response = await this.$axios.get(
          "https://api.sheety.co/17a15e538248668e7a07764e201fdfa9/calidadCmf/calidad"
        );
        this.tableData = response.data.calidad;
        let floatAttributes = ["totalDefCriticosPorcentaje", "totalPorcentajeDefectosNoCriticos"];
        const tableKeys = Object.keys(this.tableData[0]);
        for (let i = 0; i < tableKeys.length; i++) {
          if (tableKeys[i].includes("porcentaje")) {
            floatAttributes.push(tableKeys[i]);
          }
        }
        for (let i = 0; i < this.tableData.length; i++) {
          for (let j = 0; j < floatAttributes.length; j++) {
            this.tableData[i][floatAttributes[j]] = parseFloat(this.tableData[i][floatAttributes[j]]).toFixed(2);
          }
        }
        this.ready = true;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.ready = true;
        this.loading = false;
      }
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Inspeccion #" + a + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a) {
      this.$store.dispatch("toggleOverlay");
      const data = a;

      this.$axios({
        method: "post",
        url: `/production/marroni/download_pdf`,
        responseType: "arraybuffer",
        data: data
      })
        .then((response) => {
          this.forceFileDownload(response, a.id);
          this.$bvToast.toast("Inspeccion #" + a.id + " descargado", {
            title: "Descarga exitosa",
            variant: "success",
            solid: true
          });
        })
        .catch((error) => {
          this.$bvToast.toast("Inspeccion #" + a.id + " no descargado", {
            title: "Descarga fallida",
            variant: "danger",
            solid: true
          });
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch("toggleOverlay");
        });
    }
  },
  mounted() {
    moment.locale("es");
    this.getData();
    this.getProductores();
  }
};
</script>

<style scoped>
>>> .VueTables__filters-row.form-control {
  height: calc(0.5em + 0.75rem + 2px);
}

>>> .VuePagination {
  text-align: center;
  justify-content: center;
}

>>> .table td {
  padding: 0.15em;
}

>>> .vue-title {
  text-align: center;
  margin-bottom: 10px;
}

>>> .VueTables__search-field {
  display: flex;
}
>>> .VueTables__search-field input {
  margin-left: 0.12rem;
}

>>> .VueTables__limit-field {
  display: flex;
}

>>> .VueTables__limit-field select {
  margin-left: 0.1rem !important;
}

>>> .VueTables__table th {
  text-align: center;
  padding: 0.1rem;
}

>>> .VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

>>> .VueTables__child-row-toggler--closed::before {
  content: "+";
}
>>> .VueTables__columns-dropdown {
  padding-right: 20px;
}
>>> .VueTables__date-filter {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__number-field {
  border: 4px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__child-row-toggler--open::before {
  content: "-";
}
</style>
